module.exports = __webpack_public_path__ + "img/photo_260730946_1.9a9e07a3.png";